import React from 'react';
import MapContainer from '../../js/Components/Map';
import TituloPagina from '../../js/Components/PageTitle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCalendarCheck,
  faClock,
  faEnvelope,
  faLocationDot,
  faMapLocationDot,
  faMessage,
  faPhone,
  faShieldHeart,
  faTooth
} from '@fortawesome/free-solid-svg-icons';

const WHATSAPP_URL = 'https://api.whatsapp.com/send?phone=523334758191&text=Hola%20buenas%20tardes,%20me%20gustaria%20agendar%20una%20cita%20para%20su%20consultorio%20personal%20en%20Teodomiro%20Manzano%204365-B';
const FACEBOOK_URL = 'https://www.facebook.com/DentalPuente-2072424749721597';
const MAP_URL = 'https://www.openstreetmap.org/?mlat=20.65027&mlon=-103.42074#map=17/20.65027/-103.42074';

const Contact: React.FC = () => {
  return (
    <div>
      <TituloPagina title="DentalPuente | Contacto" pageSlug="contact" />

      <main className="contact-page content-wrap">
        <section className="contact-hero" aria-labelledby="contact-title">
          <div className="contact-hero-content">
            <span className="dp-eyebrow">Contacto Dental Puente</span>
            <h1 id="contact-title">Agenda tu cita sin vueltas.</h1>
            <p>
              Escríbenos por WhatsApp para resolver dudas, confirmar horarios o solicitar una consulta en nuestro consultorio.
            </p>

            <div className="contact-hero-actions">
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="contact-primary-button">
                <FontAwesomeIcon icon={faMessage} />
                Solicitar cita por WhatsApp
              </a>
              <a href="tel:+523334758191" className="contact-secondary-button">
                <FontAwesomeIcon icon={faPhone} />
                Llamar ahora
              </a>
            </div>
          </div>

          <aside className="contact-quick-card" aria-label="Información rápida">
            <div className="contact-quick-icon">
              <FontAwesomeIcon icon={faTooth} />
            </div>
            <div>
              <span>Previa cita</span>
              <strong>33 34 75 81 91</strong>
            </div>
          </aside>
        </section>

        <section className="contact-grid" aria-label="Opciones de contacto">
          <article className="contact-card contact-card-whatsapp">
            <div className="contact-card-icon">
              <FontAwesomeIcon icon={faMessage} />
            </div>
            <div>
              <span className="contact-card-kicker">Respuesta directa</span>
              <h2>WhatsApp</h2>
              <p>La vía más rápida para agendar, mover una cita o resolver preguntas antes de tu consulta.</p>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="contact-card-link">
                Escribir por WhatsApp
              </a>
            </div>
          </article>

          <article className="contact-card">
            <div className="contact-card-icon">
              <FontAwesomeIcon icon={faClock} />
            </div>
            <div>
              <span className="contact-card-kicker">Horario</span>
              <h2>Lun - Sab</h2>
              <p><strong>10:00 am - 7:00 pm</strong><br />Domingo cerrado</p>
            </div>
          </article>

          <article className="contact-card">
            <div className="contact-card-icon">
              <FontAwesomeIcon icon={faLocationDot} />
            </div>
            <div>
              <span className="contact-card-kicker">Ubicación</span>
              <h2>Guadalajara</h2>
              <p>Teodomiro Manzano 4365, Guadalajara, Jalisco.</p>
              <a href={MAP_URL} target="_blank" rel="noopener noreferrer" className="contact-card-link">
                Abrir mapa
              </a>
            </div>
          </article>
        </section>

        <section className="contact-main-panel">
          <div className="contact-info-panel">
            <span className="dp-eyebrow">Antes de visitarnos</span>
            <h2>Te ayudamos a llegar con todo claro.</h2>

            <div className="contact-info-list">
              <div className="contact-info-item">
                <FontAwesomeIcon icon={faCalendarCheck} />
                <div>
                  <h3>Agenda confirmada</h3>
                  <p>Confirma disponibilidad por WhatsApp antes de asistir.</p>
                </div>
              </div>

              <div className="contact-info-item">
                <FontAwesomeIcon icon={faShieldHeart} />
                <div>
                  <h3>Consulta tranquila</h3>
                  <p>Cuéntanos tus dudas y el motivo de tu visita para orientarte mejor.</p>
                </div>
              </div>

              <div className="contact-info-item">
                <FontAwesomeIcon icon={faEnvelope} />
                <div>
                  <h3>Redes sociales</h3>
                  <p>También puedes seguirnos y compartir tu experiencia.</p>
                  <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" className="contact-inline-link">
                    Ver Facebook
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="contact-map-panel">
            <div className="contact-map-header">
              <div>
                <span className="contact-card-kicker">Mapa</span>
                <h2>Encuéntranos aquí</h2>
              </div>
              <FontAwesomeIcon icon={faMapLocationDot} />
            </div>
            <div className="contact-map-frame">
              <MapContainer />
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Contact;
